// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterPanel-cls1_Ara","cls2":"FilterPanel-cls2_LRx FilterPanel-cls1_Ara"};